module.exports = __webpack_public_path__ + "static/media/kite_fly.e4e5ae3a.png";